/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Report_DailyInputs */

const vi_expense_report_daily = /** @type {(inputs: Expense_Report_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo cuối ngày thu/chi`)
};

/**

* @param {Expense_Report_DailyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_report_daily = /** @type {((inputs?: Expense_Report_DailyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Report_DailyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_report_daily(inputs)
});